import {
  Stepper,
  Form,
  Radio,
  Email,
  PhoneNumber,
  NameTextField,
  TextField,
  Button,
  Checkbox,
  Company,
  Select,
  DatePicker,
} from "@lmt/taskforce-react-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormLabel from "@mui/material/FormLabel";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: "small",
      },
    },
    MuiButtonGroup: {
      defaultProps: {
        size: "small",
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small",
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputBase: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputLabel: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiRadio: {
      defaultProps: {
        size: "small",
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
  },
});

function App() {
  return (
      <ThemeProvider theme={theme}>
        <Stepper
            steps={[
              <Form onSubmit={() =>
                  (window.top.location.href =
                      "https://landing-business-speaking.lmtform.com/good.html")
              }
              >
                <Box mt={-3}>
                  <Checkbox
                      name="company_naf_code"
                      label="Débloquer mon Anglais oral en utilisant mon CPF."
                      defaultChecked={false}
                      required={false}
                  />
                </Box>
                <Box mt={-3}>
                  <Checkbox
                      name="company_effective_lead"
                      label="Améliorer l'Anglais de mes équipes."
                      defaultChecked={false}
                      required={false}
                  />
                </Box>
                <Box mt={-3}>
                  <Checkbox
                      name="misc"
                      label="En savoir plus sur l'anglais oral des affaires accéléré par tél. ou visio."
                      defaultChecked={false}
                      required={false}
                  />
                </Box>
                <Box mt={-1}>
                  <Radio
                      label="Civilité"
                      name="reference_civility"
                      items={[
                        { label: "Mme.", value: 2 },
                        { label: "Mr.", value: 1 },
                      ]}
                  />
                </Box>
                <Box sx={{ display: 'flex'}}>

                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Box>
                      <NameTextField label="Nom" name="last_name" />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box>
                      <NameTextField label="Prénom" name="first_name" />
                    </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Box>
                      <Email
                          label = "Email professionnel"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                  <Box>
                    <Company
                        label="Société"
                        companyName="company_name"
                        companyAddress="address"
                        companyZipcode="company_zipcode"
                        required="Merci de saisir votre société"
                    />
                  </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Box>
                      <TextField
                          label = "Tél. fixe"
                          name="phone_number_home"
                          required={false}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box>
                      <PhoneNumber
                          label = "Tél. mobile"
                          name="phone_number_mobile"
                          required={true}
                      />
                    </Box>
                  </Grid>
                </Grid>
                <Box>
                  <FormLabel>Je suis intéressé(e) par une autre langue :</FormLabel>
                </Box>
                <Box>
                  <Select
                      name="reference_product_coregistration_educational_subject"
                      required={false}
                      items={
                        [
                          {label:"Allemand", value:"1"},
                          {label:"Espagnol", value:"4"},
                          {label:"Italien", value:"7"},
                          {label:"Portugais", value:"9"},
                          {label:"Russe", value:"16"},
                          {label:"Chinois", value:"8"},
                          {label:"Arabe", value:"6"},
                          {label:"Japonais", value:"28"},
                        ]
                      }
                  />
                </Box>
                <Box mt={-3}>
                  <TextField
                      label = "Commentaire"
                      name="project_description"
                      required={false}
                      multiline={true}
                      rows={4}
                  />
                </Box>
                <Grid container spacing={2} mt={-3}>
                  <Grid item xs={6} mt={-1}>
                    <Box>
                      <DatePicker
                          label = "Date de rappel"
                          name="birth_date"
                          required={false}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={6} mt={-1}>
                    <Box>
                      <Select
                          name="company_legal_form"
                          required={false}
                          label="Horaire de rappel"
                          items={
                            [
                              {label:"9h-12h", value:"9h-12h"},
                              {label:"12h-14h", value:"9h-12h"},
                              {label:"14h-19h30", value:"14h-19h30"},
                            ]
                          }
                      />
                    </Box>
                    <Box sx={{ display: 'none' }}>
                      <TextField
                          name="origin"
                          required={false}
                          defaultValue='Emailing Isokele'
                          hidden
                      />
                    </Box>
                  </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'center'}} mt={-2}>
                  <Button/>
                </Box>

              </Form>,
            ]}
        />
      </ThemeProvider>
  );
}

export default App;
